import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';
// Define a service using a base URL and expected endpoints
export const assetsService = createApi({
    reducerPath: 'assetsService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['Assets'],
    endpoints: (builder) => ({
        getAllAssets: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.assetsController.getAllAssets}/${body.page}/${body.size}?orderBy=${body.sort}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getAssetsById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.assetsController.getAssetsById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        saveAssets: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.assetsController.saveAssets}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        updateAssets: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.assetsController.updateAssets}/${body.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        deleteAssets: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.assetsController.deleteAssets}/${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getAllAssetsBySearch: builder.mutation({
            query(body) {
                console.log(body, "body");

                return {
                    url: `${userManagement.assetsController.getAllAssetsBySearch}`,
                    method: "POST",
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),
        findAllAssets: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.assetsController.findAllAssets}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        bulkSaveAssets: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.assetsController.bulkSaveAssets}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        getAssetRiskAssessment: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.assetsController.getAssetRiskAssessment}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        downloadRiskReport: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.assetsController.downloadReport}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                    responseHandler: (response) => response.blob(),
                    responseType: 'blob',
                }
            }
        }),
    })
});
export const {
    useGetAllAssetsMutation,
    useGetAssetsByIdMutation,
    useSaveAssetsMutation,
    useUpdateAssetsMutation,
    useDeleteAssetsMutation,
    useGetAllAssetsBySearchMutation,
    useFindAllAssetsMutation,
    useBulkSaveAssetsMutation,
    useGetAssetRiskAssessmentMutation,
    useDownloadRiskReportMutation,
} = assetsService;